// extracted by mini-css-extract-plugin
module.exports = {"Section":"Section_Section__1XCug"};